"use client";

import { useDynamicContext } from "@dynamic-labs/sdk-react-core";
import { useCallback } from "react";

import { useMirrorAccount } from "#/store/app/devMode/mirrorAccount";

export const useHandleLogOut = () => {
  const { setMirrorAccount } = useMirrorAccount();
  const { handleLogOut: logout } = useDynamicContext();

  const handleLogOut = useCallback(async () => {
    setMirrorAccount(undefined);
    await logout();
  }, [logout, setMirrorAccount]);

  return { handleLogOut };
};
